module.exports = __webpack_public_path__ + "img/eminem_web.4742f17b.jpg";